import { QueryClient } from "@tanstack/react-query";

// The app's one query cache. Code outside a component, such as a write that
// must refresh what a query shows, reaches the cache through this module.
export const queryClient = new QueryClient();
